import { z } from 'zod'
import type { DurtionHistory, RangeHistory } from '~/stores/types'

export const durationFilterSchema = z.object({
  field: z.enum([
    'handleTime',
    'recordingDuration',
    'wrapTime',
    'talkTime',
    'totalHoldTime',
  ]),
  op: z.string(),
  start: z.coerce.number().min(0).max(999),
  end: z.coerce.number().min(0).max(999),
})

export function convertDurationFormToFilter(
  input: z.infer<typeof durationFilterSchema>,
): DurtionHistory {
  if (input.op === 'between') {
    return {
      op: input.op,
      values: [`${input.start * 60}`, `${input.end * 60}`],
      field: input.field,
    }
  }
  return {
    op: input.op as 'gte' | 'lte',
    value: `${input.start * 60}`,
    field: input.field,
  }
}

export function createRangeFilterSchema(integerOnly = false) {
  const value = z.coerce.number().min(0).max(999)
  const bound = integerOnly ? value.int('Enter a whole number') : value
  return z.object({
    op: z.string(),
    start: bound,
    end: bound,
  })
}

export const defaultRangeFormatter = <V extends number | string>(
  value: V,
): string | number => value

export function convertRangeFormToFilter(
  field: RangeHistory['field'],
  input: z.infer<ReturnType<typeof createRangeFilterSchema>>,
  valueFormatter = defaultRangeFormatter,
): RangeHistory {
  if (input.op === 'between') {
    return {
      op: input.op,
      values: [`${valueFormatter(input.start)}`, `${valueFormatter(input.end)}`],
      field,
    }
  }
  return {
    op: input.op as 'gte' | 'lte',
    value: `${valueFormatter(input.start)}`,
    field,
  }
}
